import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="section-container py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                51
              </span>
              <span className="text-background-50 font-heading text-lg">51吃瓜官网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              51吃瓜爆料网与51吃瓜黑料网 — 最新娱乐八卦黑料爆料第一站。
              专注提供最真实、最快、最全的51吃瓜今日黑料，让每一位吃瓜群众都能第一时间吃到最新鲜的瓜。
            </p>
          </div>

          <div>
            <h4 className="text-background-100 font-heading text-base mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-100 font-heading text-base mb-4">热门专题</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-400">明星恋情爆料</span>
              <span className="text-sm text-background-400">综艺翻车现场</span>
              <span className="text-sm text-background-400">豪门恩怨揭秘</span>
              <span className="text-sm text-background-400">影视圈内幕</span>
              <span className="text-sm text-background-400">网红扒皮实录</span>
            </div>
          </div>

          <div>
            <h4 className="text-background-100 font-heading text-base mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2024-2026 51吃瓜官网 All Rights Reserved. 本站内容仅供娱乐参考，不构成任何投资或法律建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}